<template>
  <h1 class="text-white text-center font-bold p-4 border-b">
    دفترچه بازدید مجموعه<span class="text-yellow-500 font-bold">
      (بازدید : {{ pagination.totalRecords }})
    </span>
  </h1>
  <div class="pt-1">
    <div
      class="flex justify-center gap-4 overflow-scroll no-scrollbar snap-x py-2"
    >
      <div
        class="flex items-center justify-center h-14 w-14 text-white rounded-lg shrink-0 transition-all snap-center"
        :class="
          active1400 ? 'bg-yellow-500 transform scale-125' : 'bg-gray-900'
        "
        @click="getYear1400()"
      >
        <div class="text-center">
          <p class="font-bold text-lg">1400</p>
          <p class="text-xs">سال</p>
        </div>
      </div>
      <div
        class="flex items-center justify-center h-14 w-14 text-white rounded-lg shrink-0 transition-all snap-center"
        :class="
          active1401 ? 'bg-yellow-500 transform scale-125' : 'bg-gray-900'
        "
        @click="getYear1401()"
      >
        <div class="text-center">
          <p class="font-bold text-lg">1401</p>
          <p class="text-xs">سال</p>
        </div>
      </div>
    </div>
    <div class="flex gap-4 overflow-scroll p-2 no-scrollbar snap-x" ref="test">
      <MonthViewer
        v-for="month in 12"
        :key="month"
        :month="month"
        :active="month === selectedMonth"
        @monthClicked="
          selectedMonth = $event;
          selectedDay = '';
        "
      />
    </div>

    <div class="flex gap-4 overflow-scroll pt-2 no-scrollbar snap-x py-2">
      <DayViewer
        v-for="day in daysInMonth"
        :key="day"
        :day="day"
        :month="selectedMonth"
        :active="day === selectedDay"
        @dayClicked="selectedDay = $event"
      />
    </div>
  </div>

  <div class="mx-4">
    <router-link to="/note-list/create">
      <Button class="mt-4">بازدید جدید</Button>
    </router-link>

    <NoteCard v-for="note in notes" :key="note" :note="note" />

    <v-pagination
      v-model="pagination.pageNumber"
      :pages="pagination.totalPages"
      :range-size="1"
      active-color="#fcd34d"
      @update:modelValue="getNotes"
    />
  </div>
</template>

<script>
import NoteCard from "@/components/NoteCard";
import Button from "@/components/General/Button";
import { getCeremonies } from "../API/API";
import VPagination from "@hennge/vue3-pagination";
import "@/assets/css/pagination.css";
import MonthViewer from "../components/Management/MonthViewer";
import DayViewer from "../components/Management/DayViewer";
import jDate from "jalali-date";

export default {
  name: "NoteList",
  components: { Button, NoteCard, VPagination, MonthViewer, DayViewer },
  data() {
    return {
      pagination: {},
      notes: [],
      selectedDay: new jDate().getDate(),
      selectedMonth: new jDate().getMonth(),
      selectedYear: 1401,
      daysInMonth: "",
      active1400: false,
      active1401: true,
    };
  },
  async created() {
    this.getNotes(1);
    this.getDaysInMonth();
  },
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle("border-yellow-500");
    },
    getDaysInMonth() {
      let today = new jDate();
      // this.daysInMonth = jDate.daysInMonth(today.getFullYear(), this.selectedMonth)
      if (this.selectedMonth <= 6) {
        this.daysInMonth = 31;
        return;
      }

      if (this.selectedMonth <= 11) {
        this.daysInMonth = 30;
        return;
      }

      if (jDate.isLeapYear(today.getFullYear())) {
        this.daysInMonth = 30;
        return;
      }

      this.daysInMonth = 29;
      return;
    },
    async getNotes(pageNumber) {
      let resp = (
        await getCeremonies(
          pageNumber,
          this.selectedYear,
          this.selectedMonth,
          this.selectedDay
        )
      ).data.result;
      this.notes = resp.item1;
      this.pagination = resp.item2;
      window.scrollTo(0, 0);
    },
    getYear1400() {
      this.active1400 = true;
      this.selectedYear = 1400;
      this.active1401 = false;
    },
    getYear1401() {
      this.active1401 = true;
      this.selectedYear = 1401;
      this.active1400 = false;
    },
  },
  watch: {
    selectedDay() {
      if (this.selectedMonth != "" && this.selectedYear !== "") {
        this.getNotes(1);
      } else {
        this.selectedDay = "";
        this.$swal({
          icon: "error",
          title: "خطا",
          text: "ابتداسال و ماه راانتخاب نمایید",
          confirmButtonColor: "#fcd34d",
          confirmButtonText: "باشه",
        });
      }
    },
    selectedMonth() {
      if (this.selectedYear != "") {
        this.getNotes(1);
      } else {
        this.selectedMonth = "";
        this.$swal({
          icon: "error",
          title: "خطا",
          text: "ابتداسال راانتخاب نمایید",
          confirmButtonColor: "#fcd34d",
          confirmButtonText: "باشه",
        });
      }
    },
    selectedYear() {
      this.getNotes(1);
    },
  },
};
</script>

<style scoped></style>
